const initialSearchFields = {
  CallTagId: null,
  CallLogId: null,
  FromDate: null,
  Destination: null,
  UserId: null,
  Source: null,
  ToDate: null,
};
export default {
  data() {
    return {
      recentCallTableHeaders: [
        { text: 'تاریخ', value: 'callDate', align: 'center' },
        { text: 'از', value: 'fromTheNumber', align: 'center' },
        {
          text: 'به',
          value: 'toTheNumber',
          align: 'center',
        },
        { text: 'کاربر', value: 'userFullName', align: 'center' },
        { text: 'مدت زمان', value: 'callDuration', align: 'center' },
        { text: 'مدت انتظار', value: 'callHoldTime', align: 'center' },
        { text: 'نتیجه', value: 'result', align: 'center' },
        {
          text: 'قطع کننده',
          value: 'hangUpSide',
          align: 'center',
        },
        {
          text: 'عملیات',
          value: 'actions',
          sortable: false,
          align: 'center',
        },
      ],
      pagination: {
        Page: 1,
        PageSize: 10,
      },
      searchFields: { ...initialSearchFields },
      selectedSearchFields: { ...initialSearchFields },
      searchModal: false,
      selectedCallId: -1,
      player: false,
      recordFile: null,
      searchTitle: '',
    };
  },
  methods: {
    showFilterModal: function () {
      this.searchModal = true;
    },
    closeFilterModal: function () {
      this.searchModal = false;
    },
    searchFieldsHandler: function () {
      this.selectedSearchFields = { ...this.searchFields };
    },
    resetSearchFields: function () {
      this.searchFields = { ...initialSearchFields };
    },
    resetSelectedFields: function () {
      this.selectedSearchFields = { ...initialSearchFields };
    },
    clearFilter: function () {
      this.resetSelectedFields();
      this.resetSearchFields();
    },
    resetPage: function () {
      this.pagination = { ...this.pagination, Page: 1 };
    },
    areTwoObjectsDeferentValues: function (obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    },
    closeSearchModal: function () {
      this.resetSearchFields();
      this.closeFilterModal();
    },
    stopMusic: function () {
      const sound = this.$refs.audioFile;
      sound.pause();
      sound.currentTime = 0;
      this.player = false;
    },
  },
  computed: {
    haveFilters: function () {
      return !!Object.values(this.selectedSearchFields).filter((item) => item).length;
    },
    haveDownloadAudioPermmistion: function () {
      return [...this.$store.state?.userModule?.user?.permissions]?.some(({ id }) => id === 2);
    },
    haveListenAudioPermmistion: function () {
      return [...this.$store.state?.userModule?.user?.permissions]?.some(({ id }) => id === 1);
    },
    allFilters: function () {
      return {
        ...this.selectedSearchFields,
        ...this.pagination,
      };
    },
  },
  watch: {
    selectedSearchFields: {
      handler: function (val) {
        console.log(val);
        this.closeFilterModal();
        this.resetPage();
      },
      deep: true,
    },
    allFilters: {
      handler: function (currentVal, oldVal) {
        if (!this.areTwoObjectsDeferentValues(currentVal, oldVal)) {
          this.getRecentCallsListHandler(currentVal);
        }
      },
      deep: true,
    },
  },
};
